/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAsterix = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M13 2v8.234l8.486-5.091 1.029 1.715-8.572 5.141 8.572 5.143-1.029 1.715L13 13.765V22h-2v-8.235l-8.485 5.092-1.029-1.714L10.057 12 1.486 6.857l1.029-1.715L11 10.233V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAsterix as Asterix };
